import { produce } from 'immer';
import { Reducer } from 'redux';

import { SalesRep } from '@/controllers/SalesRep';
import { UserActionTypes } from '@/store/reducers/user/action-types';

import { SalesRepActionTypes } from './action-types';
import { initialState } from './constants';
import { SalesRepReducerState as State } from './types';

export const salesRepReducer: Reducer<State> = (state = initialState, action): State => {
  switch (action.type) {
    case UserActionTypes.FETCH_USER_INFO.SUCCESS:
      return { ...state, userId: action.payload.id };

    case SalesRepActionTypes.FETCH_ALL.SUCCESS:
      return {
        ...state,
        list: action.payload.map((salesRep: SalesRep) => ({
          ...salesRep,
        })),
      };

    case SalesRepActionTypes.MARK_AS_SELECTED:
      return {
        ...state,
        list: state.list.map(salesRep => ({
          ...salesRep,
          selected: salesRep.id === action.payload.id,
        })),
      };

    case SalesRepActionTypes.CREATE_NEW.START:
      return { ...state, newSalesRep: action.payload };

    case SalesRepActionTypes.CREATE_NEW.SUCCESS:
      return {
        ...state,
        newSalesRep: null,
        list: state.newSalesRep
          ? [
              ...state.list.map(salesRep => ({ ...salesRep, selected: false })),
              { ...state.newSalesRep, id: action.payload.id, selected: true },
            ]
          : state.list,
      };

    case SalesRepActionTypes.UPDATE_CONTACT_INFO.START:
      return { ...state, newSalesRep: action.payload };

    case SalesRepActionTypes.UPDATE_CONTACT_INFO.SUCCESS:
      return produce(state, (newState: State) => {
        newState.newSalesRep = null;
        newState.isSalesRepUpdated = true;
        newState.list = state.list.map(salesRep =>
          salesRep.id === state.newSalesRep?.id ? { ...salesRep, ...state.newSalesRep } : salesRep,
        );
      });

    case SalesRepActionTypes.UPDATE_CONTACT_INFO.CLEAN_UP:
      return { ...state, isSalesRepUpdated: false };

    default:
      return state;
  }
};
